import { render, staticRenderFns } from "./LegacyCollectionCounts.vue?vue&type=template&id=1e604b03&scoped=true&"
import script from "./LegacyCollectionCounts.vue?vue&type=script&lang=js&"
export * from "./LegacyCollectionCounts.vue?vue&type=script&lang=js&"
import style0 from "./LegacyCollectionCounts.vue?vue&type=style&index=0&id=1e604b03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e604b03",
  null
  
)

export default component.exports